import { render } from "./IndexDarkView.vue?vue&type=template&id=b1aec220"
import script from "./IndexDarkView.vue?vue&type=script&lang=js"
export * from "./IndexDarkView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__